angular
    .module('ustreet-app')
    .controller('LocationTypeCtrl', ['$scope', '$location', '$stateParams', 'locationTypeSvc',
    function ($scope, $location, $stateParams, locationTypeSvc) {
        app.bindCrud($location, $scope, $stateParams, locationTypeSvc, '/Admin/LocationTypes');
    }]);
